import * as PIXI from "pixi.js";
import { MouseClickType } from "../Settings/Enums";
import { PointHelper } from "../../HelperModules/PointHelper";
export class InteractiveContainer extends PIXI.Container {
    constructor() {
        super();
        this.mouseIsOver = false;
        this.interactive = true;
        this.on("pointerdown", this.pointerDownHandler.bind(this));
        this.on("pointermove", this.pointerMoveHandler.bind(this));
        this.on("pointerup", this.pointerUpHandler.bind(this));
        this.on("pointerupoutside", this.pointerUpHandler.bind(this));
        this.on("pointerover", this.pointerOverHandler.bind(this));
        this.on("pointerout", this.pointerOutHandler.bind(this));
    }
    pointerOverHandler(event) {
        this.mouseIsOver = true;
    }
    pointerOutHandler(event) {
        this.mouseIsOver = false;
    }
}
export class MouseTypeContainer extends InteractiveContainer {
    pointerDownHandler(event) {
        if (!this.mouseIsOver) {
            return;
        }
        switch (event.data.button) {
            case 0:
                this._mouseClickType = MouseClickType.LeftClick;
                break;
            case 1:
                this._mouseClickType = MouseClickType.MiddleClick;
                break;
            case 2:
                this._mouseClickType = MouseClickType.RightClick;
                break;
            default:
                this._mouseClickType = MouseClickType.None;
                return;
        }
        this._startPointerPosition = event.data.getLocalPosition(this.parent);
    }
    pointerMoveHandler(event) {
        return;
    }
    pointerUpHandler(event) {
        if (this._mouseClickType == MouseClickType.None || this._mouseClickType == undefined) {
            return;
        }
        else {
            if (PointHelper.distanceSquared(event.data.getLocalPosition(this.parent), this._startPointerPosition) < 10) {
                this.pointerUpClickHandler(event);
            }
            else {
                this.pointerUpDragHandler(event);
            }
        }
        this._mouseClickType = MouseClickType.None;
        this._startPointerPosition = undefined;
    }
    pointerUpClickHandler(event) {
        return;
    }
    pointerUpDragHandler(event) {
        return;
    }
}
//# sourceMappingURL=InteractiveContainer.js.map